<script>
import colors from '../../../pcp/wom'

const columns = [
    {
        key: 'no',
        align: 'center',
        title: 'No',
        width: 50,
        scopedSlots: { customRender: 'number' }
    }, {
        key: 'kpi',
        align: 'center',
        width: 300,
        title: 'Sasaran Kompetensi',
        scopedSlots: { customRender: 'kpi' }
    }, {
        key: 'weight_soft',
        align: 'center',
        title: 'Bobot (%)',
        width: 80,
        scopedSlots: { customRender: 'weight' }
    }, {
        key: 'scorer',
        align: 'center',
        title: 'Nilai',
        scopedSlots: { customRender: 'scorer' }
    }, {
        key: 'final',
        align: 'center',
        title: 'Nilai Akhir',
        width: 100,
        scopedSlots: { customRender: 'final' }
    },
     {
        key: 'wom_soft',
        align: 'center',
        title: 'WOM',
        width: 100,
        scopedSlots: { customRender: 'wom' }
    }
]

const Competency = {
    id: null,
    index: null,
    number: null,
    is_heading: false,
    is_footer: false,
    name: '',
    weight: 0,
    hash: '',
}

export default
{
    props: {
        month: {
            type: Object,
            required: true
        }
    },
    computed: {
        dateStart() {
            return this.moment(this.$laravel.training.date_start)
        },
        dateEnd() {
            return this.moment(this.$laravel.training.date_end)
        },
        tableData() {
            if (this.objectives.length > 0) {
                let idx = 0,collection = [], heading = 0, number = 0
                this.objectives.forEach(function(item,index) {
                    idx++
                    if (heading !== item.perspective.name ) {
                        collection.push(Object.assign(Object.create(Competency), {
                            id: idx,
                            number,
                            is_heading: true,
                            name: item.perspective.name,
                        }))

                        number = 0
                        heading = item.perspective.name
                        idx++
                    }

                    number++
                    collection.push(Object.assign(Object.create(Competency), {
                        id: idx,
                        index,
                        number,
                        name: item.objective,
                        weight: item.config.weight * 100,
                    }))
                })

                collection.push(Object.assign(Object.create(Competency), {
                    id: idx + 1,
                    is_footer: true,
                    name: 'Total',
                    weight: collection.reduce((a, b) => a + b.weight, 0),
                    final: this.getTotalScore(this.month.format('YYYYMM'))
                }))

                let total = collection.filter(function (el) {
                        return el.is_footer == true;
                });
                this.$emit("softTotal", total[0].final);

                return collection
            }
            return []
        },
        defaultDate(){
            return this.month
        }
    },
    data: () => ({
        columns,
        colors,
        months: [],
        loading: false,
        objectives: [],
        filters: {
            month: null
        }
    }),
    created() {
        this.getObjectives()
    },
    methods: {
        viewReport() {
            let dateSelect = this.filters.month  === null ? this.defaultDate : this.filters.month

            if (dateSelect.isBetween(this.dateStart, this.dateEnd, 'month'))
            {
                this.getObjectives()
            } else {
                this.filters.month = this.defaultDate
                this.notify({
                    key: 'performance',
                    type: 'error',
                    title: 'Out of Range',
                    message: 'Pilihan bulan tidak dalam masa pelatihan.'
                })
            }
        },
        monthlyBreakdown() {
            let columns = this.columns
            let months = []
            let current = this.moment(this.$laravel.training.date_start).startOf('month')
            let end = this.moment(this.$laravel.training.date_end).endOf('month')

            let year = {
                key: 'year_' + current.format('YYYY'),
                title: current.format('YYYY'),
                align: 'center',
                children: []
            }

            while (current.isBefore(end.endOf('month'))) {
                if (year.key !== 'year_' + current.format('YYYY')) {

                    columns.push(year)
                    year = {
                        key: 'year_' + current.format('YYYY'),
                        title: current.format('YYYY'),
                        align: 'center',
                        children: []
                    }
                }

                year.children.push({
                    key: 'month_' + current.format('MM'),
                    title: current.format('MMM'),
                    align: 'center',
                    width: 80,
                    scopedSlots: { customRender: 'month_' + current.format('YYYYMM') }
                })

                months.push(current.format('YYYYMM'))
                current = current.add(1, 'months')
            }

            columns.push(year)
            columns.push({
                key: 'final',
                title: 'Nilai Akhir',
                align: 'center',
                width: 80,
                scopedSlots: { customRender: 'final' }
            })

            this.months = months
            this.columns = columns
        },
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: 'PRF-SOC'
                    }
                })
                .then(r => this.objectives = r.data.objectives)
                .catch(err => this.handleXhrError(err))
                .finally(() => this.loading = false)
        },
        getScore(key, index) {
            let objective = this.objectives[index]

            if (objective.scores.length < 1) {
                return 0
            }
            return objective.scores[0].breakdown['raw_score_' + key]
        },

        // get total vertical score
        getTotalScore(key) {
            let total = 0
            this.objectives.forEach((o,i) => total += parseFloat(this.getScore(key, i)))

            return (total / this.objectives.length).toFixed(2)
        },

        // get total horizontal score
        getRowScore(index) {
            if (this.objectives[index].scores.length < 1)
                return 0

            let breakdown = this.objectives[index].scores[0].breakdown
            let total = 0

            // by raw
            this.months.forEach((item) => total += parseFloat(breakdown['raw_score_' + item]))

            let counter = 0
            this.months.forEach((item) => counter = breakdown['raw_score_' + item ] !== 0 ? counter + 1 : counter)

            return (total / counter).toFixed(2)

            // by average
            //return parseFloat(this.objectives[index].scores[0].breakdown.average_scores).toFixed(2)
        }
    }
}
</script>
<template>
    <div>
        <a-card type="inner" size="small">
        <a-skeleton :loading="loading" active>
            <a-table class="pcp-table" :dataSource="tableData" :columns="columns" rowKey="id" :pagination="false"  :rowClassName="(r) => r.is_heading || r.is_footer ? 'row-heading' : 'wom-' + r.wom ">
                <template slot="title" slot-scope="currentPageData">
                    <strong>SOFT COMPETENCIES</strong>
                </template>

                <div slot-scope="r" slot="number" class="text-center text-small" v-show="! r.is_heading">
                    <strong>{{ r.number }}</strong>
                </div>

                <div slot-scope="r" slot="kpi" class="text-small text-left">
                    <template v-if="r.is_heading || r.is_footer === true ">
                        <strong>{{ r.name }}</strong>
                    </template>
                    <template v-else>
                        {{ r.name }}
                    </template>
                </div>

                <div slot-scope="r" slot="weight" class="text-small text-center" v-show="! r.is_heading">
                    <strong>{{ r.weight }}%</strong>
                </div>

                <div slot-scope="r" slot="wom" class="text-small text-center" v-show="! r.is_heading">
                    <div v-if="! r.is_heading && ! r.is_footer " :style="'background-color: ' + colors['_' + getScore(month.format('YYYYMM'), r.index)] ">
                        &nbsp;
                    </div>
                </div>

                <div slot-scope="r" slot="scorer" class="text-small text-center" v-show="! r.is_heading">
                        <strong v-if="r.is_footer">{{ getTotalScore(month.format('YYYYMM')) }}</strong>
                        <strong v-else-if="! r.is_heading">{{ getScore(month.format('YYYYMM'), r.index)}}</strong>
                    </div>

                <div slot-scope="r" slot="final" class="text-small text-center" >
                    <strong v-if="r.is_footer">{{ getTotalScore(month.format('YYYYMM')) }}</strong>
                        <strong v-else-if="! r.is_heading">{{ getScore(month.format('YYYYMM'), r.index)}}</strong>
                </div>
            </a-table>
        </a-skeleton>
    </a-card>
    </div>
</template>
